export enum FLAGS {
  GAME_CENTER_FAVORITING = 'game_center_favoriting',
}
